import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils/get-action-types";
import { ERROR, INIT, LOADING, OK } from "../constants";
import { Action, WalletState } from "../models/wallet";
import { FETCH_WALLET } from "../constants/wallet";

const initialState: WalletState = {
  status: INIT,
  data: {},
  error: {},
};

function data(state: WalletState = initialState, action: Action): WalletState {
  switch (action.type) {
    case getRequestActionType(FETCH_WALLET):
      return {
        ...state,
        status: LOADING,
        error: {},
      };
    case getSuccessActionType(FETCH_WALLET):
      return {
        ...state,
        status: OK,
        error: {},
        data: action.payload,
      };

    case getFailureActionType(FETCH_WALLET):
      return {
        ...state,
        status: ERROR,
        error: action.payload,
      };

    default:
      return state;
  }
}

export default data;
